import { Center } from '@chakra-ui/react'
import { httpsCallable } from 'firebase/functions'
import { useCallback, useState } from 'react'
import { functions } from '../../../../backend/functions/functions'
import { useProfile } from '../../../../contexts/user/ProfileContext'
import { ActionButton } from '../../../Buttons'

const recoverFiles = httpsCallable(functions, 'recoverAssessmentFiles')
export const RecoverAssessmentFiles = () => {
  const { assessmentId } = useProfile()
  const [recovering, setRecovering] = useState(false)

  const recover = useCallback(async () => {
    if (!assessmentId) return
    setRecovering(true)
    try {
      await recoverFiles({ assessmentId })
    } catch (e) {
      console.error(e)
    }
    setRecovering(false)
  }, [assessmentId])
  return (
    <Center w="100%" py={1}>
      <ActionButton
        size="sm"
        bg="white"
        onClick={recover}
        isLoading={recovering}
        loadingText="Recovering...">
        Recover Assessment Files
      </ActionButton>
    </Center>
  )
}
